import { MultiLangValue } from '../types/internal/language';

export const getMultiLangValue = (value: string | MultiLangValue, lang?: string) => {
  if (typeof value === 'string') {
    return value;
  }

  return lang && value[lang] ? value[lang] : '';
};
